import {
  AriaLabel,
  AriaTagGroup,
  AriaTagList,
  formatPrice,
  KdsCardFile,
  KdsTag,
  KdsText,
} from "@kazaar-platform/design-system";
import { RiLinksLine } from "@remixicon/react";
import { T, useTranslate } from "@tolgee/react";
import dayjs from "dayjs";
import { useAtomValue } from "jotai";
import { useGetCurrency } from "@/hooks";
import { userAtom } from "@/store";
import { type QuoteDisplayProps } from "./QuoteDisplay.types";

export const QuoteDisplay = ({ itemsRelated, quote }: QuoteDisplayProps) => {
  const { t } = useTranslate();
  const userAtomValue = useAtomValue(userAtom);
  const currency = useGetCurrency();

  return (
    <div className="flex w-full flex-col gap-sp-md">
      <div className="flex flex-col">
        <div className="prose-body-sm flex flex-row items-center gap-sp-xs2 text-text-body">
          <T
            keyName="cardQuote.supplierWithStyle"
            params={{
              strong: <KdsText size="subtitle-sm" />,
              span: <KdsText />,
              number: quote.quoteNumber,
            }}
          />
        </div>

        <div className="flex items-center justify-start gap-sp-xs text-text-bodyvariant">
          <T
            keyName="cardQuote.totalPriceWithStyle"
            params={{
              span: <KdsText size="subtitle-xs" />,
              price: formatPrice({
                price: quote.totalPrice,
                maxDigits: 5,
                locale: userAtomValue?.lang,
                currency: currency,
              }),
            }}
          />

          <KdsText size="subtitle-xs">|</KdsText>
          <KdsText size="subtitle-xs">
            {t("cardQuote.sendAt", {
              date: dayjs(quote.sentAt).format("DD/MM/YYYY"),
            })}
          </KdsText>
        </div>
      </div>

      <KdsCardFile
        fileName={quote.file.fileName}
        fileSize={quote.file.size}
        fileUrl={quote.file.url}
        isViewable
      />

      <div className="flex items-center gap-sp-xs2">
        <RiLinksLine className="size-si-xs2" /> :
        <div className="flex w-full items-center">
          <AriaTagGroup>
            <AriaLabel />
            <AriaTagList className="flex flex-wrap gap-sp-xs2">
              {itemsRelated.map((item) => (
                <KdsTag key={item} state="neutral">
                  {item}
                </KdsTag>
              ))}
            </AriaTagList>
          </AriaTagGroup>
        </div>
      </div>
    </div>
  );
};
